import { createSlice } from "@reduxjs/toolkit";
import { scheduleInterview } from "./thunk";

const initialState = {
    loading: false,
    error: null as string | null,
    success: false
};

const interviewSlice = createSlice({
    name: "interview",
    initialState,
    reducers: {
        clearInterviewState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(scheduleInterview.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        });
        builder.addCase(scheduleInterview.fulfilled, (state) => {
            state.loading = false;
            state.error = null;
            state.success = true;
        });
        builder.addCase(scheduleInterview.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || null;
            state.success = false;
        });
    }
});

export const { clearInterviewState } = interviewSlice.actions;
export default interviewSlice.reducer;
